<div>
    <lib-edl-cf-label [title]="model.config.title" [for]="shouldShowBuildings ? inputId : undefined"></lib-edl-cf-label>

    <!-- Text Display -->
    <p *ngIf="!shouldShowBuildings">{{displayText}}</p>

    <!-- Building Picker - Print -->
    <p *ngIf="isPrintMode && shouldShowBuildings" edlFormVar="answer" #edlFormVar="edlFormVar">{{edlFormVar.control?.value || NO_BUILDINGS}}</p>

    <!-- Building Picker - Edit -->
    <ng-template [ngIf]="!isPrintMode && shouldShowBuildings">   
        <p *ngIf="showNoBuilding">{{NO_BUILDINGS}}</p>  
        <select *ngIf="!showNoBuilding" class="form-select" [id]="inputId" formControlName="answer">
            <option *ngFor="let building of buildings" [value]="building.name">
                {{ building.name }}
            </option>
            <option *ngIf="nonExistingBuilding" [value]="nonExistingBuilding">
                (No Longer Assigned) {{ nonExistingBuilding }} 
            </option>
        </select>
    </ng-template> 
</div>

